import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiStar } = FiIcons;

const Header = ({ onBooking }) => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed top-0 w-full bg-slate-900/95 backdrop-blur-md border-b border-amber-500/20 z-40"
    >
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-lg flex items-center justify-center">
            <SafeIcon icon={FiStar} className="text-white text-xl" />
          </div>
          <div>
            <h1 className="text-white font-bold text-lg">BAZI MASTERY</h1>
            <p className="text-amber-400 text-sm">ปาจื้อเรียกทรัพย์</p>
          </div>
        </div>

        <button
          onClick={onBooking}
          className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-6 py-2 rounded-full hover:shadow-lg hover:shadow-amber-500/25 transition-all duration-300 font-semibold flex items-center gap-2"
        >
          <SafeIcon icon={FiPhone} className="text-lg" />
          จองเลย!
        </button>
      </div>
    </motion.header>
  );
};

export default Header;